import styles from "./styles.module.scss";
import cn from "classnames";

export const OurValues = ({ title, values, className }) => {
  return (
    <section className={cn(styles.OurValues, className)}>
      <h2 className={styles.heading} data-sourceflow-prop="title">{title}</h2>
      <div className={styles.grid}>
        {values?.map(({ icon, title, description }, idx) => (
          <div key={idx} className={styles.valueBlock}>
            <div className={styles.iconWrapper}>
              <img
                src={icon?.url}
                alt=""
                className={styles.icon}
                data-sourceflow-prop={`values[${idx}].icon`}
              />
            </div>
            <div className={styles.textBlock}>
              <h3 className={styles.valueTitle} data-sourceflow-prop={`values[${idx}].title`}>
                {title}
              </h3>
              <div
                className={styles.valueDescription}
                data-sourceflow-prop={`values[${idx}].description`}
                dangerouslySetInnerHTML={{ __html: description }}
              />
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default OurValues;
